import React from 'react';
import PropTypes from 'prop-types';
import './button.scss';

const Button = ({ children, onClick, className, link, url }) =>
  link ? (
    <a
      href={url}
      target="_parent"
      className={
        className ? `button button--link ${className}` : 'button button--link'
      }
      rel="noreferrer"
    >
      {children}
    </a>
  ) : (
    <button onClick={onClick} type="button" className={`button ${className}`}>
      {children}
    </button>
  );

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  link: PropTypes.bool
};

export default Button;
